// removed by extract-text-webpack-plugin
module.exports = {"article":"src-templates----ministries-module---article---1B-rs","articleTitle":"src-templates----ministries-module---articleTitle---3CH1c","articleContent":"src-templates----ministries-module---articleContent---eFT1C","component":"src-templates----ministries-module---component---20QwG"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/ministries.module.scss
// module id = 185
// module chunks = 131463666383785 258425949895071